module.exports = __webpack_public_path__ + "img/urun-gorseli-hazirlaniyor.19153e57.svg";